'use strict';

const $ = require('jquery');
const Template = require("./../lib/template");
const Event = require("./../lib/events");

class Incident {

    constructor() {
        const cookieName = 'ozhz_closed_incidents';

        /**
         * Render incidents
         */
        let $incidentHolder = $('#incidents');
        if ($incidentHolder.length > 0) {
            // Fetch previously closed incidents from browser cookie so they aren't shown again
            let closedIncidents = this.parseCookie(cookieName);
            this.fetchIncidents(closedIncidents)
                .then((data) => {
                    if (data.posts.length > 0) {
                        Template.render($incidentHolder, `${rk_globals.theme_path}/views/parts/incident/set.twig`, data);

                        // ajax-ready event is triggered when template rendering is complete
                        Event.on('site:ajax-ready', window, () => {
                            /**
                             * Record closed incidents in browser cookie
                             */
                            let incidentCloseButtons = Array.from(document.querySelectorAll('.incident__close'));
                            if (incidentCloseButtons.length > 0) {
                                incidentCloseButtons.map(button => {
                                    button.addEventListener('click', () => {
                                        let incidentId = parseInt(button.dataset.incidentId);
                                        let element = document.querySelector('#incident-' + incidentId);
                                        if (element !== null) {
                                            element.parentNode.removeChild(element);
                                            this.updateCookie(cookieName, incidentId);
                                        }
                                    });
                                });
                            }
                        });
                    }
                });
        }
    }

    /**
     * Fetch incidents from the database, excluding those already closed
     *
     * @param [closedIncidents]
     * @returns {Promise<*>}
     */
    async fetchIncidents(closedIncidents) {
        try {
            return await $.ajax({
                url: '/api/incidents/get/',
                data: {
                    json: true,
                    closed_incidents: closedIncidents
                },
                dataType: 'json'
            });
        } catch (error) {
            if (App.Globals.debug) {
                console.log(error);
            }
        }
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        
        return false;
    }

    setCookie(name, data) {
        document.cookie = `${name}=${data};path=/`;
    }

    parseCookie(name) {
        let data = this.getCookie(name);
        return data === false ? [] : JSON.parse(data);
    }

    updateCookie(name, value) {
        let cookieData = this.parseCookie(name);
        cookieData.push(value);
        this.setCookie(name, JSON.stringify(cookieData));
    }
}

module.exports = Incident;
